import { Component, ElementRef, OnInit, Renderer, ViewEncapsulation,ViewChildren, QueryList, } from '@angular/core';
import { UtilService } from 'src/app/shared/services/util.service';
import { HandleRequestService } from 'src/app/shared/services/handle-request.service';
import { APIResponse } from 'src/app/shared/models/api-response';
import { ActivatedRoute } from '@angular/router';
import { Student } from 'src/app/shared/models/student';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-runner3',
  templateUrl: './runner3.component.html',
  styleUrls: ['./runner3.component.css'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class Runner3Component implements OnInit {
  @ViewChildren('canvas') canvasElements: QueryList<ElementRef<HTMLCanvasElement>>;
  canvases = [
    { brushColor: '#000000', brushSize: 1, isEraser: false, drawing: false, context: null },
    { brushColor: '#000000', brushSize: 1, isEraser: false, drawing: false, context: null },
    { brushColor: '#000000', brushSize: 1, isEraser: false, drawing: false, context: null },
    { brushColor: '#000000', brushSize: 1, isEraser: false, drawing: false, context: null },
    { brushColor: '#000000', brushSize: 1, isEraser: false, drawing: false, context: null },
  ];

  
  resultData: any[] = [];
  student: Student;
  isIOS = false;

  defaultData = [
    [], // 0
    ['59', '33', '29', '11', '30', '59', '21', '75', '61'], // 1
    ['58', '50', '28', '67', '27', '86', '9', '46', '58'], // 2
    [], // 3
    ['203', '297', '225', '145', '136', '154', '184', '112', '154', '477', '112', '301', '171', '144', '116', '162'], // 4
    [], // 5
    ['51', '22', '65', '14', '40', '29', '41', '64', '65', '10', '40', '30', '78', '42', '40'], // 6
    [
      '0', '1', '0', '0', '1', '0', '0', '0', '0', '0', '1',
      '0', '1', '0', '0', '1', '0', '0', '0', '0', '1', '1',
      '0', '1', '0', '0', '1', '0', '1', '0', '0', '1', '1',
      '0', '1', '0', '0', '1', '0', '1', '0', '0', '1', '1',
      '0', '1', '0', '0', '1', '0', '1', '0', '0', '1', '1',
      '0', '1', '1', '1', '1', '1', '1', '0', '0', '1', '1',
      '0', '1', '0', '0', '1', '0', '1', '0', '0', '1', '1',
      '0', '1', '1', '1', '1', '1', '1', '1', '1', '1', '1',
      '0', '0', '0', '0', '0', '0', '1', '0', '0', '1', '0',
      '0', '0', '0', '0', '0', '0', '1', '0', '0', '1', '0',
      '1', '1', '1', '1', '1', '0', '1', '0', '0', '1', '0'
    ], // 7
    ['311', '313', '289', '254', '276', '245', '135', '148', '182'], // 8
    ['444', '243', '311', '444', '434', '441', '112', '231', '321'], // 9
    ['2.11', '3.1', '4.44', '3.44', '2.42', '1.23', '2.13', '3', '4.44'], // 10
    ['3675', '1380', '1730', '2348', '3924', '2709', '5352', '6104', '2160', '4476', '3820', '5058'], // 11
    ['14', '15', '9', '19', '4', '9', '19', '7', '19', '17', '41', '5', '11', '31', '18'], // 12
    [], // 13
    [], // 14
    [], // 15
    ['238', '296', '291', '273', '275', '297', '175', '144', '180'], // 16
    ['444', '122', '310', '210', '445', '122', '300', '221', '120'], // 17
    ['1.2', '2.2', '0.22', '3.85', '3.1', '2.05', '2.01', '5.21', '2.03'], // 18
    ['966', '2019', '1344', '2349', '1734', '3168', '2298', '1536', '5873', '3501'], // 19
    [], // 20
    [], // 21
    ['46', '41', '28', '34', '33', '42', '39', '14', '34', '43', '64', '58', '62', '73', '63'], // 22
    [], // 23
    ['127', '101', '100', '99', '162', '97', '171', '92', '42'], // 24
    ['1638', '864', '3432', '1602', '2670', '1458', '1572', '2840', '1320', '875'], // 25
    [], // 26
    [], // 27
    ['22', '67', '7', '8', '17', '49', '21', '12', '48', '50', '58', '51', '32', '11', '26'], // 28
    ['2', '7', '5', '1', '7', '8', '1', '3', '7', '6', '2', '9'], // 29
    ['103', '226', '110', '159', '166', '100', '243', '52', '158'], // 30
    ['464', '854', '551', '554', '399', '795', '754', '789', '577'], // 31
    ['7.67', '7.78', '7.64', '8.74', '4.57', '7.68', '9.47', '8.46', '4.98'], // 32
    ['1728', '1156', '894', '3437', '5082', '5238', '2688', '2360', '2130', '2607'], // 33
    [], // 34
    [], // 35
    ['12', '63', '21', '59', '27', '25', '41', '12', '9', '57', '31', '52', '32', '34', '25'], // 36
    ['54', '64', '99', '216', '164', '108', '275', '75', '192', '98'], // 37
    [], // 38
    ['273', '266', '273', '311', '314', '256', '209', '267', '158'], // 39
    ['221', '410', '648', '579', '476', '250', '265', '480', '899'], // 40
    ['2.55', '5.42', '2.23', '3.13', '1.22', '6.41', '3.51', '5.24', '6.12'], // 41
    ['5070', '1645', '658', '6858', '2175', '1076', '11394', '27156', '6956', '12985'], // 42
    [], // 43
    [], // 44
    ['16', '15', '18', '27', '49', '15', '13', '14', '13', '18', '44', '53', '24', '13', '11'], // 45
    ['69', '168', '256', '125', '96', '648', '192', '88', '504', '115'], // 46
    [
      '1', '1', '1', '1', '0', '0', '0', '0', 
      '0', '0', '0', '0', '0', '1', '0', '0', 
      '1', '1', '1', '1', '1', '1', '0', '0', 
      '0', '0', '0', '0', '0', '1', '0', '0', 
      '0', '1', '1', '1', '1', '1', '0', '0', 
      '0', '1', '0', '0', '0', '1', '0', '0', 
      '0', '1', '0', '0', '0', '1', '0', '0', 
      '0', '1', '0', '1', '1', '1', '1', '1',
      '0', '0', '0', '0', '0', '0', '0', '0'
    ], // 47
    ['177', '348', '293', '335', '258', '303', '367', '354', '303'], // 48
    ['350', '245', '452', '433', '322', '432', '425', '423', '205'], // 49
    ['5.44', '5.33', '4.25', '3.04', '7.78', '7.96', '4.24', '4.51', '2.61'], // 50
    ['1575', '1892', '2589', '1168', '1185', '2744', '1356', '3918', '3816', '4504'], // 51
    [], // 52
    [], // 53
    ['51', '54', '90', '81', '25', '84', '54', '54', '46', '25', '94', '24', '62', '43', '94'], // 54
    ['90', '102', '64', '318', '441', '168', '268', '376', '135', '304'], // 55
    [], // 56
    ['184', '59', '13', '119', '136', '109', '219', '153', '211'], // 57
    ['701', '301', '601', '549', '980', '667', '870', '220', '869'], // 58
    ['2.19', '2.99', '3.96', '1.96', '1.39', '2.34', '1.69', '6.9', '0.37'], // 59
    ['9804', '10120', '71028', '6710', '18375', '35938', '28140', '13964', '25992', '29616'], // 60
    [], // 61
    [], // 62
    ['51', '52', '41', '33', '94', '73', '8', '6', '87', '93', '34', '47', '34', '45', '95'], // 63
    ['388', '380', '516', '108', '215', '224', '100', '265', '240', '204'], // 64
    [
      '5', '7', '4', '9', '6', '3', '9', '8', '1', '4', '6', '1', '5', '4', '8', '3', '8', '6', '4', '5', 
      '9', '6', '2', '8', '7', '6', '5', '2', '4', '3', '5', '7', '9', '9', '2', '5', '4', '8', '4', '7', 
      '2', '1', '3'
    ], // 65
    ['214', '262', '239', '250', '315', '133', '319', '349', '141'], // 66
    ['634', '542', '634', '248', '183', '723', '357', '145', '372'], // 67
    ['0.37', '0.91', '6.9', '2.34', '2.19', '1.39', '1.96', '3.96', '2.99'], // 68
    ['9248', '11817', '13748', '16872', '20829', '18376', '12729', '13980', '17732', '27720'], // 69
    [], // 70
    [], // 71
    ['74', '43', '93', '84', '64', '35', '17', '23', '18', '60', '15', '22', '78', '46', '7'], // 72
    ['592', '828', '384', '441', '351', '444', '266', '258', '686', '469'], // 73
    ['6', '3', '4', '2', '1', '4', '3', '6', '5', '4', '2', '4', '6', '2', '3', '4', '1', '6', '1', '3'], // 74
    ['246', '137', '103', '188', '98', '67', '121', '139', '129'], // 75
    ['37', '858', '891', '516', '848', '773', '275', '450', '248'], // 76
    ['8.02', '3.38', '9.27', '3.69', '5.19', '6.54', '8.32', '3.89', '5.89'], // 77
    ['26232', '8724', '2678', '19116', '22588', '10476', '9544', '19722', '46370', '14064'], // 78
    [], // 79
    ['34', '67', '77', '41', '61', '74', '5', '64', '64', '22', '51', '65', '65', '5', '5'], // 80
    ['256', '285', '176', '380', '468', '198', '328', '217', '182', '891'], // 81
    ['1', '3', '3', '4', '6', '6', '1', '2', '8', '4', '0', '1', '1', '1', '3', '0', '2', '1', '3', '9', '6', '1',
       '1284', '2001', '1396', '1261', '1664', '1113', '1334'], // 82
    ['268', '129', '309', '232', '197', '120', '347', '273', '240'], // 83
    ['574', '877', '936', '389', '274', '451', '535', '451', '469'], // 84
    ['3.22', '2.45', '2.41', '2.53', '5.86', '7.03', '6.82', '9.39', '5.44'], // 85
    [], // 86
    [], // 87
    ['40', '34', '25', '20', '13', '93', '73', '49', '56', '35', '16', '15', '18', '15', '53'], // 88
    ['378', '609', '846', '165', '348', '66', '315', '624', '189', '322'], // 89
    ['162', '141', '98', '94', '173', '76', '359', '327', '149', '123'], // 90
    ['2004', '368', '221', '390', '134', '159', '229', '297', '531', '448'], // 91
    ['6.81', '5.89', '4.79', '7.4', '5.56', '8.68', '8.07', '9.6', '8.75', '8.27'], // 92
    ['256', '285', '176', '380', '198', '328', '217', '182'], // 93
    [], // 94
    [], // 95
    [], // 96
    ['74', '30', '16', '54', '66', '65', '39', '55', '32', '62', '25', '13', '21', '4', '10', '13', '4', '21', '11', '9'], // 97
    ['385', '99', '204', '456', '14', '300', '290', '520', '96', '116'], // 98
  ];
  type = 'runner3';

  constructor(
    private utilService: UtilService,
    private httpService: HandleRequestService,
    private route: ActivatedRoute,
    private elRef: ElementRef,
    private toastr: ToastrService,
    private renderer: Renderer
  ) { }

  ngOnInit() {
    if (/iPad|iPhone|iPod/.test(window.navigator.userAgent)) {
      this.isIOS = true;
    }

    for (var i = 0; i < 129; i++) {
      this.resultData.push({
        values: [],
        times: '',
        count: 0,
        correctAnswers: 10,
        resultIsIncorrect: [false,false,false,false,false,false,false,false,false,false],
        finished: false
      })
    }
    
    this.route.data.subscribe(x => {
      if (x.hasOwnProperty('profile')) {
        const response = x.profile as APIResponse;
        this.student = response.data as Student;
      }

      this.httpService.post('/smartpdf/get', {
        type: this.type,
        user_id: this.student._id,
      }).then(
        (res: APIResponse) => {
          if (res.data.smartpdf) {
            this.resultData = res.data.smartpdf.data.result;
          }
          this.canvases.forEach((canvas, index) => {
            if (!canvas.context) {
              canvas.context = this.canvasElements.toArray()[index].nativeElement.getContext('2d');
            }
          });
          this.loadDrawing();
        }, () => {
         
        }
      );
      
    });
  }

  startDrawing(e: TouchEvent, index: number): void {
    const canvas = this.canvases[index];
    canvas.drawing = true;
    const canvasElement = this.canvasElements.toArray()[index].nativeElement;
    const rect = canvasElement.getBoundingClientRect();
    const event = e.touches[0];
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    canvas.context.beginPath();
    canvas.context.moveTo(x, y);
  }

  draw(e: TouchEvent, index: number): void {
    const canvas = this.canvases[index];
    if (!canvas.drawing) return;
    const canvasElement = this.canvasElements.toArray()[index].nativeElement;
    const rect = canvasElement.getBoundingClientRect();
    const event = e.touches[0];
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    canvas.context.lineTo(x, y);
    canvas.context.stroke();
  }

  stopDrawing(index: number): void {
    const canvas = this.canvases[index];
    canvas.drawing = false;
    canvas.context.closePath();
  }

  startDrawing1(event: MouseEvent, index: number): void {
    const canvas = this.canvases[index];
    canvas.drawing = true;
    const canvasElement = this.canvasElements.toArray()[index].nativeElement;
    const rect = canvasElement.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    canvas.context.beginPath();
    canvas.context.moveTo(x, y);
  }

  draw1(event: MouseEvent, index: number): void {
    const canvas = this.canvases[index];
    if (!canvas.drawing) return;
    const canvasElement = this.canvasElements.toArray()[index].nativeElement;
    const rect = canvasElement.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    canvas.context.lineTo(x, y);
    canvas.context.stroke();
  }

  stopDrawing1(index: number): void {
    const canvas = this.canvases[index];
    canvas.drawing = false;
    canvas.context.closePath();
  }

  saveDrawing(index: number): void {
    this.toastr.info('Saving...');
    const canvasElement = this.canvasElements.toArray()[index].nativeElement;
    const dataURL = canvasElement.toDataURL();
    this.httpService.post('/smartcanvas/update', {
      type: this.type,
      user_id: this.student._id,
      serial: index,
      data: dataURL
    }).then(
      (res: APIResponse) => {
        this.toastr.clear();
        this.toastr.success('Successfully Saved');
      }, () => {
      }
    );
  }

  async loadDrawing() {
    for (var index in this.canvases) {
      this.httpService.post('/smartcanvas/get', {
        type: this.type,
        user_id: this.student._id,
        serial: index
      }).then(
        (res: APIResponse) => {
          if (res.data.smartcanvas) {
            const img = new Image();
            img.onload = () => {
            const canvasElement = this.canvasElements.toArray()[index].nativeElement;
              const context = canvasElement.getContext('2d');
              context.clearRect(0, 0, canvasElement.width, canvasElement.height);
              context.drawImage(img, 0, 0);
            };
            img.src = res.data.smartcanvas.data;
          }
        }, () => {
         
        }
      );

      await this.delay(2000);
    }
    
  }

  backToSavedImage(index: number) {
    this.httpService.post('/smartcanvas/get', {
      type: this.type,
      user_id: this.student._id,
      serial: index
    }).then(
      (res: APIResponse) => {
        if (res.data.smartcanvas) {
          const img = new Image();
          img.onload = () => {
          const canvasElement = this.canvasElements.toArray()[index].nativeElement;
            const context = canvasElement.getContext('2d');
            context.clearRect(0, 0, canvasElement.width, canvasElement.height);
            context.drawImage(img, 0, 0);
          };
          img.src = res.data.smartcanvas.data;
        }
      }, () => {
       
      }
    );
  }

  clearCanvas(index: number): void {
    const canvasElement = this.canvasElements.toArray()[index].nativeElement;
    const context = canvasElement.getContext('2d');
    context.clearRect(0, 0, canvasElement.width, canvasElement.height);
  }

  canvasPropertiesChanges(): void {
    this.canvases.forEach(canvas => {
      if (!canvas.isEraser) {
        canvas.context.strokeStyle = canvas.brushColor;
      }
      canvas.context.lineWidth = canvas.brushSize;
    });
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  quastionConfirm(index) {
    this.resultData[index].finished = true;
    if (this.resultData[index].count < 2) {
      this.resultData[index].count++;
      let allCorrect = true;
      for (let i in this.defaultData[index]) {
        if (this.defaultData[index][i] != this.resultData[index].values[i]) {
          allCorrect = false;
        }
      }
      if (!allCorrect && this.resultData[index].count == 1) {
        this.toastr.error('Corrige el resultado en rojo y vuelve a picar. Solo tienes una oportunidad de corregir.');
      }
    }
    this.saveData();
  }

  quastionChange(index) {
    this.resultData[index].finished = false;
  }

  clickedNumbers(i, j) {
    if (this.resultData[i].finished && this.resultData[i].count >= 2) {
      return;
    }
    this.resultData[i].finished = false;
    if (this.resultData[i].values[j] == '1') {
      this.resultData[i].values[j] = '0';
    } else {
      this.resultData[i].values[j] = '1';
    }
  }

  quastionConfirm1(index) {
    this.resultData[index].finished = true;
    this.saveData();
  }

  correctAnswerCheck(i, j) {
    if (!this.resultData[i].resultIsIncorrect[j] && this.resultData[i].finished){
      if (document.activeElement && document.activeElement !== document.body) {
        this.renderer.invokeElementMethod(
          this.elRef.nativeElement.ownerDocument.activeElement, 'blur');
      }
      this.resultData[i].resultIsIncorrect[j] = true;
      this.resultData[i].correctAnswers--;
      this.saveData();
    }
  }

  saveData() {
    this.toastr.info('Saving...');
    this.httpService.post('/smartpdf/update', {
      type: this.type,
      user_id: this.student._id,
      data: {
        result: this.resultData
      }
    }).then(
      (res: APIResponse) => {
        this.toastr.success('Saved');
      }, () => {
      }
    );
  }
}
